<template>
    <b-modal
            :no-close-on-backdrop="true"
            :lazy="true"
            :ref="'form-view-accountmanagers'"
            :id="'form-view-accountmanagers'"
            title="Toewijzen aan"
            size="md">
        <div>
            <input data-hj-whitelist class="form-control" type="search" v-model="q" placeholder="Naam" aria-label="Search" />

            <div class="detail-list mt-2">
                <strong>Resultaten:</strong>
                <div class="results">
                    <div class="list-group list-group-flush">

                        <a @click="select(result)" v-for="result in searchResults" class="list-group-item">

                            <div class="d-flex justify-content-between align-items-center text-sm-left">
                                <div style="flex-grow: 10; flex-basis:0;">
                                    {{result.name ? result.name : '-'}}
                                </div>
                                <div>
                                    <i class="fas fa-chevron-right"></i>
                                </div>
                            </div>
                        </a>

                    </div>
                </div>
            </div>

        </div>
        <div slot="modal-footer" class="w-100">
            <div class="d-flex justify-content-between align-items-center">
                <div class="text-muted">
                    <small v-if="loaded!==null">
                        <a class="refresh force" @click="refresh()"><em class="fa fa-sync"></em> <timeago :since="loaded":auto-update="30"></timeago> bijgewerkt</a>
                    </small>
                    <small v-if="loaded===null">
                        <em class="fa fa-sync fa-spin"></em> Bezig met ophalen van resultaten
                    </small>
                </div>

                <button class="btn btn-light float-right" @click="hide">
                    Annuleren
                </button>
            </div>
        </div>
    </b-modal>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                results: [],

                loaded: null,

                errors: [],

                q: '',
            }
        },
        props: {
            id: [String]
        },
        watch: {
            results() {
                this.$store.commit('accountmanagersStore/accountmanagers', this.results);
            }
        },
        mounted() {
            this.selected = this.value;
            if(this.$store.getters['accountmanagersStore/accountmanagers'] !== null) {
                this.results = this.$store.getters['accountmanagersStore/accountmanagers'];
                this.loaded = new Date();
            } else {
                this.refresh();
            }
        },
        computed: {
            searchResults() {
                let q = this.q;

                if(!q || q.length < 1) {
                    return this.results;
                }

                return window._.filter(this.results, function (row) {
                    if(!row || !row.hasOwnProperty('name')) {
                        return false;
                    }
                    return row.name.toLowerCase().includes(q.toLowerCase());
                });
            }
        },
        methods: {
            show() {
                this.$refs['form-view-accountmanagers'].show();
            },
            hide() {
                this.$refs['form-view-accountmanagers'].hide();
            },
            refresh() {
                this.showing = null;
                this.loaded = null;
                this.errors = [];

                axios.get('/api/v1/leads/ep/accountmanagers')
                    .then(response => {
                        this.loaded = new Date();
                        this.results = response.data;
                    })
                    .catch(error => {
                        this.loaded = new Date();
                        if (typeof error.response.data === 'object') {
                            if(error.response.data.errors) {
                                this.errors = _.flatten(_.toArray(error.response.data.errors));
                            } else {
                                this.errors = [error.toString()];
                            }
                        } else {
                            this.errors = ['Something went wrong. Please try again.'];
                        }
                    });
            },
            select(result) {
                this.$emit('selected', result);
                this.hide();
            }
        }
    }
</script>

<style lang="scss">
    .loader {
        margin-top: -22px;
        margin-left: 12px;
    }
</style>